module.exports = __webpack_public_path__ + "img/facebook.3dbdf96a.svg";